import { Injectable } from '@angular/core';
import { RouterParamsService } from '../../shared/services/router-params.service';
import { BaseEntityService } from '../entity-management/services/base/base-entity.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Finding } from '../models/finding';

@Injectable({
  providedIn: 'root',
})
export class FindingEntityService extends BaseEntityService<Finding> {

  constructor(
    httpClient: HttpClient,
    routerParamsService: RouterParamsService,
  ) {
    super(
      httpClient,
      environment.apiUrl, { singular: 'finding', plural: 'findings' },
      routerParamsService
    );
    this.nameId = 'findingId';
  }
}
